export default __webpack_public_path__ + "static/media/aerobite_boost.6f2d25ae.webp";